import React from 'react';
import { COLORS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import { EmbedWrapper } from 'app/components/tv/preview/SharedPreviewStyles';
import styled from 'styled-components';
import { getTeaserIcon } from 'app/components/tv/helpers/getTeaserIcon';
const DEFAULT_FONT_SIZE = SIZES['12'];
const Overlay = styled.div.withConfig({
  componentId: "sc-1ifmrdw-0"
})(["position:absolute;display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding:", ";top:0;left:0;width:100%;height:100%;z-index:1;background:radial-gradient(rgba(0,0,0,0),rgba(0,0,0,0.5));"], SIZES['8']);
const EmbedHeader = styled.div.withConfig({
  componentId: "sc-1ifmrdw-1"
})(["display:flex;align-items:center;"]);
const TeaserStatus = styled.div.withConfig({
  componentId: "sc-1ifmrdw-2"
})(["display:flex;align-items:center;justify-content:center;width:", ";height:", ";min-width:", ";padding:", ";margin-right:", ";background:", ";"], SIZES['34'], SIZES['34'], SIZES['34'], SIZES['3'], SIZES['8'], props => props.updated ? "no-repeat center/100% url('/VideoTeaserGradient.svg')" : 'none');
const TeaserTitle = styled(Typography).withConfig({
  componentId: "sc-1ifmrdw-3"
})(["font-size:", ";font-weight:bold;text-transform:uppercase;"], DEFAULT_FONT_SIZE);
const EmbedCaptions = styled.div.withConfig({
  componentId: "sc-1ifmrdw-4"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;"]);
const StyledCaption = styled(Typography).withConfig({
  componentId: "sc-1ifmrdw-5"
})(["font-size:", ";display:inline-flex;color:", ";"], DEFAULT_FONT_SIZE, COLORS.white);
const VideoPreview = _ref => {
  let {
    thumbnail,
    updated,
    source,
    title,
    caption
  } = _ref;
  const icon = getTeaserIcon(source);
  return /*#__PURE__*/React.createElement(EmbedWrapper, {
    "data-sentry-element": "EmbedWrapper",
    "data-sentry-component": "VideoPreview",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Video,
    src: thumbnail,
    width: 192,
    height: 128,
    ratio: "3:2",
    "data-sentry-element": "Image",
    "data-sentry-source-file": "VideoPreview.tsx"
  }), /*#__PURE__*/React.createElement(Overlay, {
    "data-sentry-element": "Overlay",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, /*#__PURE__*/React.createElement(EmbedHeader, {
    "data-sentry-element": "EmbedHeader",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, /*#__PURE__*/React.createElement(TeaserStatus, {
    updated: updated,
    "data-sentry-element": "TeaserStatus",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, icon), /*#__PURE__*/React.createElement(TeaserTitle, {
    variant: "title1",
    "data-sentry-element": "TeaserTitle",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, title)), /*#__PURE__*/React.createElement(EmbedCaptions, {
    "data-sentry-element": "EmbedCaptions",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, /*#__PURE__*/React.createElement(StyledCaption, {
    variant: "caption1",
    "data-sentry-element": "StyledCaption",
    "data-sentry-source-file": "VideoPreview.tsx"
  }, caption))));
};
export default VideoPreview;